import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/scripts/login.component';

const authRoutes: Routes = [
  {
    path: 'login', component: LoginComponent
  }
   
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class AuthRoutingModule { }




// WEBPACK FOOTER //
// ./src/app/authentication/auth-routing.module.ts